import { render, staticRenderFns } from "./ChecklistCriteriaTable.vue?vue&type=template&id=5a4031ec&scoped=true"
import script from "./ChecklistCriteriaTable.vue?vue&type=script&lang=js"
export * from "./ChecklistCriteriaTable.vue?vue&type=script&lang=js"
import style0 from "./ChecklistCriteriaTable.vue?vue&type=style&index=0&id=5a4031ec&prod&lang=css"
import style1 from "./ChecklistCriteriaTable.vue?vue&type=style&index=1&id=5a4031ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4031ec",
  null
  
)

export default component.exports